import {
  addSlug,
  geolocationSchema,
  slimUserSchema,
  thumbnailRequiredSchema,
} from 'shared';
import {z} from 'zod';

import {AssetType} from '../../types';

const baseSchema = z.object({
  id: z.string(),
  location: geolocationSchema.nullable(),
  modified: z.coerce.date(),
  created: z.coerce.date(),
  name: z.string(),
  thumbnail: z.string(),
  type: z.enum(AssetType),
  projectCount: z.number().nonnegative(),
  memberIds: z.string().array(),
  uploaderIds: z.string().array(),
  createdBy: slimUserSchema.nullable(),
  site: z
    .object({
      id: z.string(),
      name: z.string(),
      thumbnail: z.string(),
    })
    .transform(addSlug),
});

export const assetListSchema = baseSchema.transform(addSlug).array();

export const assetSchema = baseSchema
  .extend({
    severityScaleId: z.string().min(1),
    categoryIds: z.string().array(),
    layoutName: z.string().nullable(),
    layoutTemplateId: z.string().nullable(),
    has3dProjects: z.boolean(),
  })
  .transform(addSlug);

export const assetPayloadSchema = z
  .object({
    name: z.string().trim().min(2).max(30),
    type: z.enum(AssetType),
    thumbnail: thumbnailRequiredSchema,
    siteId: z.string(),

    members: z.string().array(),
    uploaders: z.string().array(),

    presets: z.string().array(),
    categories: z.string().array(),

    severityScale: z.string().min(1),

    layoutTemplateId: z.string().min(1),
  })
  .refine(({presets, categories}) => presets.length || categories.length, {
    message: 'Must have at least 1 category or category preset.',
    path: ['categories'],
  });
